import React, { ReactElement } from "react";

import { Col, Row } from "react-bootstrap";

import { isArray } from "lodash";

import TabBar, { Tab } from "../../Atoms/TabBar/TabBar";

const BannerThreeToEightCols = ({
  heading,
  content,
  defaultActiveKey,
}: {
  heading: string;
  content: Tab[] | ReactElement;
  defaultActiveKey?: string;
}) => {
  return (
    <Row className="justify-content-between">
      <Col md={3}>
        <h2>{heading}</h2>
      </Col>
      <Col md={8}>
        {isArray(content) ? <TabBar tabs={content} defaultActiveKey={defaultActiveKey} /> : <div>{content}</div>}
      </Col>
    </Row>
  );
};

export default BannerThreeToEightCols;
